import CommonService from "@/services/CommonService"
import { useAppStore } from "@/stores/appStore"
const BASE_URI = "school/survey"

export default {
  listCacheable(params) {
    const appStore = useAppStore()
    return appStore.fetchListCached(`${BASE_URI}?${params}`)
  },
  getStartSurvey(entity) {
    return $api(`${BASE_URI}/start`, {
      method: "POST",
      body: CommonService.formData(entity),
    })
  },
  updateSurvey(entity) {
    return $api(`${BASE_URI}/update`, {
      method: "POST",
      body: CommonService.formData(entity),
    })
  },
  getLaunchYears() {
    return $api(`${BASE_URI}/launchYear`)
  },
  pingSurvey(entity) {
    return $api(`${BASE_URI}/ping`, {
      method: "POST",
      body: CommonService.formData(entity),
    })
  },
  getProgramType() {
    return $api("/school/program-type?limit=999")
  },
  getProgramMajor() {
    return $api("/school/program-major/?limit=100")
  },
  getMajorSpeciality(programLevel) {
    const appStore = useAppStore()
    return appStore.fetchListCached(
      `/school/program-major?filter_programLevel=${programLevel}`
    )
  },
  getSpeciality(speacialityId, programId) {
    const appStore = useAppStore()
    return appStore.fetchListCached(
      `/school/program/by-speciality?spec=${speacialityId}&limit=999&sortByRanking=${programId}&has_campaign_status=open`
    )
  },
  markCurrentStep(entity) {
    return $api(`${BASE_URI}/mark-current-step`, {
      method: "POST",
      body: CommonService.formData(entity),
    })
  },
  fisnishSurvey(entity) {
    return $api(`${BASE_URI}/finish`, {
      method: "POST",
      body: CommonService.formData(entity),
    })
  },
  getParentSurvey(surveyId) {
    return $api(`recruiter/survey/get-parent-survey/${surveyId}`)
  },
}
